<template>
  <router-view />
  <v-container fluid class="fill-height">
    <v-row>
      <v-col class="d-flex justify-center">
        <v-img
            :src="require('../assets/LogoApp.png')"

            contain
            height="200"
        />

      </v-col>
      <v-progress-circular
          color="green"
          class="loading"
          indeterminate
      ></v-progress-circular>
    </v-row>

  </v-container>


</template>

<script>


import router from "@/router";

export default {
  name: 'Splesh',
  data: () =>({
    auth : {
      token: "",
      user :{
        name : "",
        phone : "",
        profile : "",
      }
    }
  }),
  mounted () {
    this.intervalid1 = setInterval(() => {
      this.auth.token = localStorage.getItem("token");
      this.auth.user.name = localStorage.getItem("user_name");
      this.auth.user.phone = localStorage.getItem("user_phone");
      this.auth.user.profile = localStorage.getItem("user_profile");
      if(this.auth.token !=null){
        window.location.href = '/home'
      }else{
        window.location.href = '/login'
      }

    }, 3000);
  }
}
</script>
<style>
  .loading{
    position: absolute;
    top: 65%;
    left: 49%;
  }

</style>
